/**
 * Promotes the server-rendered user state into `user.connectedUser`, which is the shape the
 * user slice selectors expect.
 *
 * The JWT is not seeded here: `syncConnectedUserToken` mirrors it onto `connectedUser` right
 * after the store is created, and keeps it in sync on every refresh.
 */
export const initConnectedUser = (initState: any = {}) => {
    if (initState.user) {
        Object.assign(initState.user, {
            initialize: true,
            connectedUser: { ...initState.user },
        });
    }

    if (initState.customer) {
        const { customer } = initState;

        Object.assign(initState, {
            feed: {
                ALL: customer.feedAll,
                PUBLIC: customer.feedPublic,
                entities: {},
            },
        });
    }

    return initState;
};
